import axios from "axios";
import {notifyError} from "@/utils/notify-helper";

export function transformTransport(transport: string):string {
  return transport.replace(' ', '_').toLowerCase()
}

export function directDownload(uri: string, params?: any):Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      let urlLinkResponse:any = await axios({
        url: uri,
        params: params,
      })
      let link = urlLinkResponse.data.link;
      let filename = link.split('/').pop().split('#')[0].split('?')[0];
      console.log(filename)
      let fileContentResponse:any = await axios({
        url: link,
        method: 'GET',
        responseType: 'blob',
      })
      let fileURL = window.URL.createObjectURL(new Blob([fileContentResponse.data]));
      let fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

export function directDownloadLK(uri: string, params?: any):Promise<void> {
  return new Promise(async (resolve, reject) => {
    try {
      let res:any = await axios({
        url: uri,
        params: params,
      })
      // let filename = link.split('/').pop().split('#')[0].split('?')[0];
      let fileURL = window.URL.createObjectURL(new Blob([b64DecodeUnicode(res.data.filedata)]));
      let fileLink = document.createElement('a');
      // fileLink.href = "data:text/csv;charset=utf-8,"+b64DecodeUnicode(res.data.filedata)
      fileLink.href = fileURL
      fileLink.setAttribute('download', res.data.filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
      resolve()
    } catch (err) {
      notifyError(err);
      // reject(err)
    }
  })
}

export function b64DecodeUnicode(str: string) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

export function b64EncodeUnicode(str: string) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
  }))
}

export async function readFileAsBinary(file: Blob) {
    let readPromise = new Promise<any>((resolve, reject) => {
      let fr = new FileReader();
      fr.onerror = reject;
      fr.onload = () => resolve(new Uint8Array(<ArrayBuffer>fr.result));
      fr.readAsArrayBuffer(file);
    });
    const byteArray: Uint8Array = await readPromise;
    let fileString: string = '';
    let len = byteArray.byteLength;
    for (let i = 0; i < len; i++) {
      fileString += String.fromCharCode(byteArray[i]);
    }
    return fileString
}

export async function readFileAsText(file: Blob) {
  let readPromise = new Promise<any>((resolve, reject) => {
    let fr = new FileReader();
    fr.onerror = reject;
    fr.onload = () => resolve(fr.result);
    fr.readAsText(file);
  });
  return await readPromise;
}